var LOGGER_NAME = "Local";
var isReady = function () { return true; };
var logError = function (error, data) {
    console.error("[Local Logger] - Error: ", error);
    console.error("[Local Logger] - Data: ", data);
};
var logInfo = function (info, data) {
    console.log("[Local Logger] - ".concat(info), data);
};
var logWarning = function (warning, data) {
    console.log("[Local Logger] - Warning:", warning);
    console.log("[Local Logger] - Data: ", data);
};
export default {
    id: LOGGER_NAME,
    Logger: {
        isReady: isReady,
        error: logError,
        info: logInfo,
        warning: logWarning,
    },
};
